import { checkAddress } from '@polkadot/util-crypto';

/**
 * List of prefixes for DOT Chain 
 * https://github.com/paritytech/ss58-registry/blob/main/ss58-registry.json
 * 
 * Validate DOT Chain Address
 * https://github.com/polkadot-js/common/blob/master/packages/util-crypto/src/address/check.ts
 */
export default {
    isValidAddress(address, currency, opts = {}) {
        const prefix = Number(currency.prefix);
        return this.checkPolkadotAddress(address, prefix);
    },
    checkPolkadotAddress(address, prefix) {
        const [result, message] = checkAddress(address, prefix);
        return result;
    }
};

